export var setHolidays = function setHolidays(state, payload) {
  state.holidays = payload;
};